var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-bar'),_vm._v(" "),_c('div',{staticClass:"relative md:ml-64 bg-main"},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"px-4 md:px-10  mx-auto w-full pt-24 pb-12 overflow-y-auto h-full"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d6304b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Layout.vue
// module id = null
// module chunks = 